// Shared vs-prior-window delta formatter for the Trending page's spike
// cards, legend chips, Velocity column and Emerging list. `delta_pct: null`
// means there is no prior snapshot window to compare against yet (a story
// under 12h old, or a zero-baseline previous window — spec section 9) — that
// is not +100% growth, so it renders as "—" (spec section 10), not a
// percentage.
export interface FormattedDelta {
    text: string;
    toneClass: string;
}

export function formatDelta(delta: number | null, digits = 0): FormattedDelta {
    if (delta === null) {
        return {text: '—', toneClass: 'text-ink-muted'};
    }
    const sign = delta >= 0 ? '+' : '';
    return {
        text: `${sign}${delta.toFixed(digits)}%`,
        toneClass: delta >= 0 ? 'text-safe' : 'text-risk',
    };
}
